import { render, staticRenderFns } from "./CourseRow.vue?vue&type=template&id=d2782e48&scoped=true&"
import script from "./CourseRow.vue?vue&type=script&lang=js&"
export * from "./CourseRow.vue?vue&type=script&lang=js&"
import style0 from "./CourseRow.vue?vue&type=style&index=0&id=d2782e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2782e48",
  null
  
)

export default component.exports